import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import SearchExperiments from 'bundles/epic/clients/search';

// new autocomplete
export const getShowNewAutocomplete = () => SearchExperiments.preview('showNewAutocomplete');
export const impressIntoNewAutocompleteExperiment = () => SearchExperiments.get('showNewAutocomplete');
// filter experiment utils
export const impressIntoFilterExperiment = () => SearchExperiments.get('serpFilterVariant');
export const isInFilterTestVariant = () => SearchExperiments.preview('serpFilterVariant');
export const impressIntoEQPFilterExperiment = () => SearchExperiments.get('eqpFilterVariant');
export const isInEQPFilterTestVariant = () => SearchExperiments.preview('eqpFilterVariant');
export const impressIntoBrowseFilterExperiment = () => SearchExperiments.get('browseFilterVariant');
export const isInBrowseFilterTestVariant = () => SearchExperiments.preview('browseFilterVariant');
// end filter variant utils

// Browse in SERP experiment utils
export const getShouldShowBrowseInSERP = () => GrowthDiscoveryExperiments.preview('showBrowseInSerp');
export const getShouldShowBrowseInSERPWithImpression = () => GrowthDiscoveryExperiments.get('showBrowseInSerp');

export const getSuggestionsSearchEngine = (isValidSearchSuggestionExperimentPage: boolean) => {
  if (isValidSearchSuggestionExperimentPage) {
    return SearchExperiments.get('suggestionsSearchEngine');
  }
  return null;
};

export const getConsumerProductsSearchHeavyRanker = () => SearchExperiments.get('consumerProductsSearchHeavyRanker');

export function impressCoachInSearch() {
  GrowthDiscoveryExperiments.get('coachInSearch');
}

export function showCoachInSearch(): boolean {
  return GrowthDiscoveryExperiments.preview('coachInSearch') !== 'control';
}

export const getShowRegistrationGate = () => GrowthAcquisitionExperiments.get('showRegistrationGate');

export const getAutoApplyFilters = () => SearchExperiments.preview('autoApplyFilters');
export const getAutoApplyFiltersWithImpression = () => SearchExperiments.get('autoApplyFilters');
export const getEQPAutoApplyFilters = () => SearchExperiments.get('eqpAutoApplyFilters');
export const getEQPAutoApplyFiltersWithImpression = () => SearchExperiments.get('eqpAutoApplyFilters');

// NL SearchSuggestions exclusion list
// Queries in this list will NOT use NL (Natural Language) SearchSuggestions
const NL_SEARCH_SUGGESTIONS_EXCLUSION_LIST: readonly string[] = [
  'free',
  'free courses with certificate',
  'free courses',
  'free certificate courses',
  'free course with certificate',
  'free  courses with certificate',
  'free course',
  'free/',
  'free certificate',
  'free guided projects',
  'free certificate course',
  'free degree',
  'free online courses',
  'cursos gratis',
  'gratis',
  'cursos gratis en español',
  'free certification',
  'free certificat courses',
  'free cources',
  'free courses with free certificate',
  'free courses with certificates',
  'free  courses',
  'free certification courses',
  'free certifications',
  '1 hour free',
  'free course less than 2 hours',
  'free projects',
  '/free',
  'free with certificate',
  'free online course',
  'free certification course',
  'free corse',
  'free online courses with certificate',
];

/**
 * Preview version: Checks if a query should use NL (Natural Language) SearchSuggestions
 * without impressing the user into the experiment.
 * First checks if the query is in the exclusion list. If not, previews the experiment value.
 * @param query - The search query string
 * @returns true if query should use NL SearchSuggestions, false otherwise
 */
export const isNlSuggestionQueryPreview = (query: string): boolean => {
  if (!query || query.trim() === '') {
    return false;
  }
  const normalizedQuery = query.trim().toLowerCase();

  // First check if query is in exclusion list
  if (NL_SEARCH_SUGGESTIONS_EXCLUSION_LIST.includes(normalizedQuery)) {
    return false;
  }

  // If not in exclusion list, preview experiment value without impressing
  return SearchExperiments.preview('nlSuggestionQuery');
};

/**
 * Checks if a query should use NL (Natural Language) SearchSuggestions.
 * First checks if the query is in the exclusion list. If not, impresses the user
 * into the experiment and returns the experiment value.
 * @param query - The search query string
 * @returns true if query should use NL SearchSuggestions, false otherwise
 */
export const isNlSuggestionQuery = (query: string): boolean => {
  if (!query || query.trim() === '') {
    return false;
  }
  const normalizedQuery = query.trim().toLowerCase();

  // First check if query is in exclusion list
  if (NL_SEARCH_SUGGESTIONS_EXCLUSION_LIST.includes(normalizedQuery)) {
    return false;
  }

  // If not in exclusion list, impress user into experiment and return experiment value
  return SearchExperiments.get('nlSuggestionQuery');
};
